/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Targetagelabel2Inputs */

const en_targetagelabel2 = /** @type {(inputs: Targetagelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intended age`)
};

const de_targetagelabel2 = /** @type {(inputs: Targetagelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedachtes Alter`)
};

/**
* | output |
* | --- |
* | "Intended age" |
*
* @param {Targetagelabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const targetagelabel2 = /** @type {((inputs?: Targetagelabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetagelabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_targetagelabel2(inputs)
	return de_targetagelabel2(inputs)
});
export { targetagelabel2 as "targetAgeLabel" }